const state = {
    hls: null
};

const actions = {
    changeVideoQuality({commit, dispatch}, value) {
        commit('SET_CURRENT_LEVEL', value);
    },
    initializeHls({commit, dispatch}, hlsInstance) {
        commit('SET_HLS', hlsInstance);
    }
};

const mutations = {
    SET_CURRENT_LEVEL(state, value) {
        state.hls.currentLevel = value;
    },
    SET_HLS(state, hlsInstance) {
        state.hls = hlsInstance;
    }
};

export default {
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/video.js